export type Verdict = 'green' | 'red' | 'ambiguous';
export type CardKind = 'profile' | 'message' | 'behavior' | 'quote';
export type Category =
  | 'isolation'
  | 'love-bombing'
  | 'dismissiveness'
  | 'fast-escalation'
  | 'limit-pushing'
  | 'deflection'
  | 'respect'
  | 'support'
  | 'transparency'
  | 'vetting-readiness'
  | 'self-awareness';

export interface ScenarioCard {
  id: string;
  kind: CardKind;
  /** Fictional person's name (always fictional) */
  name: string;
  /** Optional context shown above the content, like "first week of texting". */
  context?: string;
  /** Optional age — only for profile-kind cards. */
  age?: number;
  /** The main text the user is judging. */
  content: string;
  verdict: Verdict;
  category: Category;
  /** 2–3 sentences explaining why this is what it is. */
  explanation: string;
}

export interface SessionRecord {
  date: string;
  total: number;
  correct: number;
  /** category → { right, wrong } */
  byCategory: Record<Category, { right: number; wrong: number }>;
}

/**
 * Cumulative stats across every round the visitor has played in this
 * browser. Persisted under `rfgf:lifetime`. Lets the visitor see
 * patterns mastery accumulating instead of treating each round as a
 * one-shot game.
 */
export interface LifetimeStats {
  /** How many rounds the visitor has completed in total. */
  roundsPlayed: number;
  /** Total questions answered across all rounds. */
  totalAnswered: number;
  /** Total correct answers across all rounds. */
  totalCorrect: number;
  /** Cumulative right/wrong per pattern category. */
  byCategory: Record<Category, { right: number; wrong: number }>;
}

export const CATEGORY_LABELS: Record<Category, string> = {
  isolation: 'isolation',
  'love-bombing': 'love-bombing',
  dismissiveness: 'dismissiveness',
  'fast-escalation': 'fast escalation',
  'limit-pushing': 'limit-pushing',
  deflection: 'deflection',
  respect: 'respect',
  support: 'support',
  transparency: 'transparency',
  'vetting-readiness': 'vetting readiness',
  'self-awareness': 'self-awareness',
};
